import React, { useContext, useEffect } from 'react';
//import PropTypes from 'prop-types';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import CateringContext from '../../../CateringContext';
import { useStyles } from '../../../../home/useStyles';
import FormInfo from './FormInfo';
import EditFormFields from './EditFormFields';
import FaqAndSubmission from './FaqAndSubmission';

function FormSettings() {
    const { restauHook } = useContext(RestauInfoContext);
    useEffect(() => {}, [restauHook.restauId]);
    const { configLoading, setConfigLoading } = useContext(CateringContext);
    const classes = useStyles();

    return (
        <div>
            {configLoading ? (
                <img
                    className={classes.loadingImage}
                    src="/img/spinner.gif"
                    alt="loading"
                />
            ) : (
                <>
                    <FormInfo />
                    <br />
                    <br />
                    <EditFormFields />
                    <br />
                    <br />
                    <FaqAndSubmission />
                </>
            )}
        </div>
    );
}

FormSettings.propTypes = {};

export default FormSettings;
